import { ShapeProps, Slide, TextProps } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from '@features/executive-report/slides/slide-master';
import { centeredImage } from '@features/executive-report/slides/centered-image';
import { theme } from '../domain/theme';

const LOGO_HEIGHT = 1.19;
const LOGO_WIDTH = 2.92;
const LOGO_X = 1.16;
const LOGO_Y = 2.06;

export const buildCampaignOverviewSlide = (
  texts: TextProps[],
  dimensionShapes: ShapeProps[],
  brandLogoWithMetadata: ImageWithMetadata | null,
  lineOptions: {
    x: number;
    y: number;
  }
): Slide => {
  const images = brandLogoWithMetadata
    ? [
        centeredImage({
          image: brandLogoWithMetadata,
          x: LOGO_X,
          y: LOGO_Y,
          maxWidth: LOGO_WIDTH,
          maxHeight: LOGO_HEIGHT,
        }),
      ]
    : [];

  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts,
    shapes: [
      {
        shapeName: 'line',
        options: {
          line: {
            color: theme.colors.inmarketGreen,
            width: 2.25,
          },
          h: 4.46,
          w: 0,
          x: lineOptions.x,
          y: lineOptions.y,
        },
      },
      ...dimensionShapes,
    ],
    images,
  };
};
